import { render, staticRenderFns } from "./RegistrationForm.vue?vue&type=template&id=c1ed6a06&scoped=true&"
import script from "./RegistrationForm.vue?vue&type=script&lang=js&"
export * from "./RegistrationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1ed6a06",
  null
  
)

export default component.exports